// 顾客满意度调查表
<template>
  <div class="projectFormLess">
    <!-- 第一行-项目名称 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_xiangm@2x.png" alt />
        <span>项目名称</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_project_name}}</span>
      </div>
    </div>
    <!-- 第二行-委托单位 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icon_gs@2x.png" alt />
        <span>委托单位</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_company_name}}</span>
      </div>
    </div>
    <!-- 第三行--项目负责人and日期 -->
    <div class="towRow" style="margin-bottom:35px">
      <div class="towRowBox">
        <div class="leftLabel">
          <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
          <span>项目负责人</span>
        </div>
        <div class="rightInput">
          <span class="isNotSubmitSpan">{{S_nickname}}</span>
        </div>
      </div>
      <!-- <div class="towRowBox">
        <div class="leftLabel leftLabel2">
          <img style="width:17px" src="../../assets/image/icon_riqi@2x.png" alt />
          <span>日期</span>
        </div>
        <div class="rightInput">
          <el-date-picker
            :disabled="!isSubmit"
            v-model="addFormData.start_date"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
      </div>-->
    </div>
    <!-- 第三下行-评价人员 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icon_gs@2x.png" alt />
        <span>评价人员</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_contacts}}</span>
      </div>
    </div>
    <!-- 第四行--对评价工作的满意程度： -->
    <!-- <div class="oneRow" style="margin-bottom:20px">
      <div class="leftLabel" style="width:300px">
        <img style="width:15px" src="../../assets/image/icon_many@2x.png" alt />
        <span>对评价工作的满意程度：</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:50px;">
      <p
        class="liRadioWithInput"
        style="display:flex;justify-content: space-between; margin-bottom:20px;"
        v-for="item in liRadioWithInputOptions"
        :key="item.name"
      >
        <span class="title" style="width:450px; min-width: 450px;" :title="item.name">{{item.name}}</span>
        <el-radio-group v-model="item.value" :disabled="!isSubmit">
          <el-radio :label="0">合格</el-radio>
          <el-radio :label="1">不合格</el-radio>
        </el-radio-group>
      </p>
    </div>-->
    <!-- 第五行--评价项目完成后，对本企业的安全技术改进是否有促进作用，具体有哪些作用？ -->
    <!-- <div class="oneRow" style="margin-bottom:23px">
      <div class="leftLabel" style="width:650px">
        <img style="width:15px" src="../../assets/image/icon_zuoy@2x.png" alt />
        <span>评价项目完成后，对本企业的安全技术改进是否有促进作用，具体有哪些作用？</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
      <el-input
        :disabled="!isSubmit"
        v-model="addFormData.technology_facilitation"
        placeholder="请输入具体的促进作用"
        type="textarea"
      ></el-input>
    </div>-->
    <!-- 第六行--评价项目完成后，对企业的安全管理是否有促进作用，具体有哪些作用？ -->
    <!-- <div class="oneRow" style="margin-bottom:23px">
      <div class="leftLabel" style="width:650px">
        <img style="width:15px" src="../../assets/image/icon_zuoy@2x.png" alt />
        <span>评价项目完成后，对企业的安全管理是否有促进作用，具体有哪些作用？</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
      <el-input
        :disabled="!isSubmit"
        v-model="addFormData.management_facilitation"
        placeholder="请输入具体的促进作用"
        type="textarea"
      ></el-input>
    </div>-->
    <!-- 第七行--对评价机构和评价师的意见或建议： -->
    <!-- <div class="oneRow" style="margin-bottom:23px">
      <div class="leftLabel" style="width:650px">
        <img style="width:15px" src="../../assets/image/icon_yijian@2x.png" alt />
        <span>对评价机构和评价师的意见或建议：</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
      <el-input
        :disabled="!isSubmit"
        v-model="addFormData.comments"
        placeholder="请输入您的意见与建议"
        type="textarea"
      ></el-input>
    </div>-->
    <!-- 签字 -->
    <!-- <div class="writeName" style="margin-bottom:25px">
      <img style="width:16px;margin-right:10px" src="../../assets/image/icon_qian@2x.png" alt />
      <span style="width:100px">反馈人签字</span>
      <img
        v-if="!addFormData.sign_office"
        @click="handleReceiverFlag1"
        style="width:66px;"
        src="../../assets/image/zaixianqianm@2x.png"
        alt
      />
      <img
        v-if="addFormData.sign_office"
        @click="handleReceiverFlag1(addFormData.sign_office)"
        style="width:66px;"
        :src="addFormData.sign_office"
        alt
      />
    </div>-->
    <!-- 日期 -->
    <!-- <div class="rightTimeRow" style="margin-bottom:30px">
      <img style="width:17px" src="../../assets/image/icon_riqi@2x.png" alt />
      <span style="color:#333;margin:0 10px">日期</span>
      <el-date-picker
        :disabled="!isSubmit"
        v-model="addFormData.date"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
    </div>-->
    <!-- 第五行--上传附件 -->
    <div class="oneRow">
      <div class="leftLabel upLoadLabel">
        <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
        <span>上传附件</span>
      </div>
      <div class="rightInput">
        <upload-file
          :isSubmit="isSubmit"
          :imgList="this.addFormData.annex"
          :detailsImgList="detailsImgList"
          @my-upload-change="upLoadChange"
        ></upload-file>
      </div>
    </div>

    <!-- 审批备注 -->
    <div class="oneRow" style="margin-bottom:35px;margin-top:20px" v-if="addFormData.is_approve==1">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>审批备注</span>
      </div>
      <div class="rightInput">
        <el-input v-model="approval_remark"></el-input>
      </div>
    </div>

    <!-- 按钮行 -->
    <div class="btnRow">
      <el-button @click="handleSubmit('1')" v-if="addFormData.is_edit!='1'">保存草稿</el-button>
      <el-button
        style="background-color:#40A0F2"
        @click="handleSubmit('0')"
        v-if="addFormData.is_edit!='1'"
      >提交</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('-1')"
        style="background-color:#f4a029"
      >驳回</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('1')"
        style="background-color:#40A0F2"
      >审批通过</el-button>
    </div>
    <!-- 按钮行 -->
    <!-- 签名组件 -->
    <sign-dialog
      @wirtDoen="handleWriteDone1"
      :visible.sync="receiverSignFlag1"
      @change="handleReceiverSign"
    ></sign-dialog>
    <!-- 签名组件 -->

    <!-- 查看进度 -->
    <project-flow
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectFlowLog="this.addFormData.approval_log"
      :projectName="this.addFormData.project_name"
      :companyName="this.addFormData.company_name"
      :projectId="this.addFormData.project_id"
    ></project-flow>
    <go-finance
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectId="this.addFormData.project_id"
    ></go-finance>

    <!-- 签名详情弹窗 -->
    <el-dialog
      :visible.sync="showDetailsDia"
      width="50%"
      class="addUserDia imgDetailsDia"
      :before-close="showDetailsDiaClose"
    >
      <div class="diaContainer">
        <img :src="showDetailsSign" alt />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ProjectFlow from '../ProjectFlow'
import GoFinance from '../GoFinance'
import SignDialog from '../SignDialog'
import UploadFile from '../UploadFile'
export default {
  data() {
    return {
      showDetailsSign: '',
      showDetailsDia: false,

      S_project_name: '',
      S_company_name: '',
      S_nickname: '',
      S_contacts: '',
      approval_remark: '',
      isSubmit: true,
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      details_project_id: '',
      details_project_status: '',
      addFormData: {
        audit_content_json: '',
        technology_facilitation: '',
        management_facilitation: '',
        sign_office: '',
        comments: '',
        date: '',
        start_date: '',
        annex: '',
      },
      // 文件上传组件
      detailsImgList: [],
      submitImgList: [],
      // 文件上传组件
      // 签名
      receiverSignFlag1: false,
      receiverSignFlag2: false,
      writeDoneImg1: '',
      writeDoneImg2: '',
      // 签名
      topBarActive: '1',
      infop: '',
      value: '',
      liRadioWithInputOptions: [
        {
          name: '1.评价机构的收费是否合理？',
          value: '',
          remark: '',
        },
        {
          name: '2.评价机构是否能按照评价项目合同规定的时间完成评价报告？',
          value: '',
          remark: '',
        },
        {
          name: '3.评价机构是否向其他第三方泄露了本企业的技术及商业秘密？',
          value: '',
          remark: '',
        },
        {
          name: '4.评价结论是否客观？',
          value: '',
          remark: '',
        },
        {
          name: '5.评价机构人员的专业技术水平如何？',
          value: '',
          remark: '',
        },
        {
          name: '6.评价机构从业人员的工作作风和敬业精神如何？',
          value: '',
          remark: '',
        },
        {
          name: '7.对评价机构技术服务质量的总体评价如何？',
          value: '',
          remark: '',
        },
      ],
    }
  },
  methods: {
    // *审批提交
    async handleExamine(val) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)

      param.append('approval_status', val)
      param.append('remark', this.approval_remark)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/satisfaction_approval',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      // this.$router.push('/project/index')
      this.getProjectDetails()
    },
    // *编辑提交
    async handleSubmit(val) {
      this.addFormData.audit_content_json = JSON.stringify(
        this.liRadioWithInputOptions
      )
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)

      param.append('is_draft', val)

      // param.append('audit_content_json', this.addFormData.audit_content_json)
      // param.append(
      //   'technology_facilitation',
      //   this.addFormData.technology_facilitation
      // )
      // param.append(
      //   'management_facilitation',
      //   this.addFormData.management_facilitation
      // )
      // param.append('comments', this.addFormData.comments)
      // param.append('sign_office', this.addFormData.sign_office)
      // param.append('date', this.addFormData.date)
      // param.append('start_date', this.addFormData.start_date)

      param.append('annex', JSON.stringify(this.submitImgList))

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/satisfaction',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      // this.$router.push('/project/index')
      this.getProjectDetails()
    },
    // *获取详情
    async getProjectDetails() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/satisfaction_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      // 判断是不是首次到此流程
      if (res.datas.info.is_new != 1) {
        this.addFormData = res.datas.info
      } else {
        this.addFormData.is_edit = res.datas.info.is_edit
      }
      // 判断禁用
      if (this.addFormData.is_draft != '1' && this.addFormData.is_edit == '1') {
        this.isSubmit = false
      }
      // 项目名称
      this.S_project_name = res.datas.info.project_name
      this.S_company_name = res.datas.info.company_name
      this.S_nickname = res.datas.info.contacts
      this.S_contacts = res.datas.info.evaluator_info.nickname
      // 判断表格
      if (this.addFormData.audit_content_json) {
        this.liRadioWithInputOptions = this.addFormData.audit_content_json
      }
      // 判断文件上传
      if (this.addFormData.annex) {
        this.detailsImgList = this.addFormData.annex
        this.submitImgList = this.addFormData.annex
      }
      // 判断日期
      if (
        this.addFormData.date == 'undefined' ||
        this.addFormData.date == 'null'
      ) {
        this.addFormData.date = ''
      }
      if (
        this.addFormData.start_date == 'undefined' ||
        this.addFormData.start_date == 'null'
      ) {
        this.addFormData.start_date = ''
      }
      // 判断签名
      if (
        this.addFormData.sign_office == 'undefined' ||
        this.addFormData.sign_office == 'null'
      ) {
        this.addFormData.sign_office = ''
      }
      console.log('顾客满意度调查表', this.addFormData)
    },
    // 文件上传
    upLoadChange(data) {
      console.log('文件列表', data)
      this.submitImgList = data
    },
    // 签名
    handleWriteDone1(data) {
      this.addFormData.sign_office = data
    },

    handleReceiverFlag1(url) {
      if (!this.isSubmit) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }
      this.receiverSignFlag1 = true
    },
    handleReceiverSign() {},
    // 签名
    handleTopBarClikc(val) {
      this.topBarActive = val
    },
    async handleBefore(file) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('file', file)
      const { data: res } = await this.$axios({
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: '/api/User/uploadImg',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success('上传成功')
      this.editUserForm.avatar = res.datas.img_url
      console.log('头像', this.editUserForm.avatar)
    },
    showDetailsDiaClose() {
      this.showDetailsDia = false
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    if (this.details_project_status && this.details_project_id) {
      this.getProjectDetails()
    }
  },
  components: {
    SignDialog,
    UploadFile,
    ProjectFlow,
    GoFinance,
  },
}
</script>
<style lang="less" scoped>
@import url(../project/projectForm.less);
</style>